export default __webpack_public_path__ + "left-arrow-1.png";